/**
 * A única porta do navegador para o servidor.
 *
 * Toda chamada leva o token do Clerk no cabeçalho. O token vive 60 segundos, e
 * quem o renova é o próprio Clerk — `getToken()` devolve o atual ou um novo.
 */
type PegarToken = () => Promise<string | null>;

let pegarToken: PegarToken = async () => null;

/** Chamado uma vez, quando o Clerk carrega (ver `main.tsx`). */
export function usarToken(fn: PegarToken) {
  pegarToken = fn;
}

export function tokenAtual() {
  return pegarToken();
}

export class ErroApi extends Error {
  constructor(
    mensagem: string,
    readonly status: number,
    /** "sessao" ou "clinica": o que falta para a chamada fazer sentido. */
    readonly falta?: "sessao" | "clinica",
  ) {
    super(mensagem);
  }
}

export async function api<T>(caminho: string, init: RequestInit = {}): Promise<T> {
  const token = await pegarToken();
  const headers = new Headers(init.headers);
  if (token) headers.set("authorization", `Bearer ${token}`);
  if (init.body) headers.set("content-type", "application/json");

  let r: Response;
  try {
    r = await fetch(`/api/painel${caminho}`, { ...init, headers });
  } catch {
    throw new ErroApi("Sem conexão com o servidor. Confira a internet e tente de novo.", 0);
  }
  const corpo = (await r.json().catch(() => null)) as { erro?: string; falta?: "sessao" | "clinica" } | null;
  if (!r.ok) throw new ErroApi(corpo?.erro ?? `O servidor respondeu ${r.status}.`, r.status, corpo?.falta);
  return corpo as T;
}
